import * as React from 'react';

export enum ProductEmptyImageDataHook {
  Image = 'product-empty-image',
}
export const ProductEmptyImage: React.FC = () => (
  <img
    data-hook={ProductEmptyImageDataHook.Image}
    src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D"
    width="0"
    height="0"
    alt=""
  />
);
